import type { FC } from "react"

import { isString } from "fp-ts/lib/string"
import { motion } from "framer-motion"
import { useTranslation } from "react-i18next"
import { useRecoilValue } from "recoil"
import styled from "styled-components"

import type { Interlingual } from "~/i18n/types"
import { fontWeight } from "~/utils/styles"

import { EdgeDesignator } from "./EdgeDesignator"
import type { Tool } from "../../state/tool"
import { TOOL_LABELS, toolState } from "../../state/tool"

export const PROPERTIES_FOR_: Readonly<Partial<Record<Tool, FC>>> = {
  EdgeDesignator,
}

const PropertiesPanel = styled(motion.section)`
  background: var(--white);
  border: 1px solid var(--grey-border);
  border-left: none;
  border-right: none;
  box-sizing: border-box;
  h2 {
    ${fontWeight(600)};
    text-transform: capitalize;
    color: var(--blue);
    /* letter-spacing: 0.05em; */
    padding: 10px;
    padding-bottom: 0;
  }
`

export const ToolProperties: FC = () => {
  const tool = useRecoilValue(toolState)
  const Properties = PROPERTIES_FOR_[tool]
  const { t } = useTranslation()
  const labelKey: Interlingual = TOOL_LABELS[tool]
  const label = t(labelKey)

  return Properties ? (
    <PropertiesPanel>
      <h2>{isString(label) && label}</h2>
      <Properties />
    </PropertiesPanel>
  ) : null
}
